module.exports = __webpack_public_path__ + "static/assinatura-banner-mobile-ad90822f430f2b56268fd16005a8e179.jpg";